export default __webpack_public_path__ + "images/21de97b46c6715e8e0a3a239f6bdcb56-pride.webp";